/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import React, { useEffect, useState } from "react";
import { ResultItem } from "./result-item";
import { SearchFilterBar } from "./search-filter-bar";
import { getCategory, getCategoryName } from "data/resources/model-category-options";
import { useAuth } from "cms/auth/hooks/use-auth";

const LargeCalendarFilter = (props) => {

    const {
        type,
        selectedCategory,
        enableBar,
    } = props;
    const { token } = useAuth();
    const [models,setModels] = useState();

    const categories = getCategory(type);
    const categoryName = getCategoryName(type);
    const [term,setTerm] = useState();
    const [category,setCategory] = useState(selectedCategory);
    const [pagination,setPagination] = useState();
    const page = 1;
    const pageSize = 10;
    const [loading,setLoading] = useState(false);

    const fetchFeed = async (token) => {
        let options = { type, page, pageSize, term };
        if (category) {
            options = { type, page, pageSize, term, category, categoryName };
        }
        setLoading(true);
        const { pagination, results: models } = await SimpliCityAdminSDK.model.findEventFeed(token, options);
        setModels(models);
        setLoading(false);
        setPagination(pagination);
    };
    const runSearch = async () => {
        await fetchFeed(token);
    };
    const total = pagination?.total;
    const first = ((page-1) * pageSize) +1;
    let last =  ((page) * pageSize);
    last = (total < pageSize) ? total : last;
    const hasResults = total > 0;

    useEffect(() => {
        fetchFeed(token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, category]);

    useEffect(() => {
        setCategory(selectedCategory);
    }, [selectedCategory]);

    return (
        <>
            {enableBar &&
                <SearchFilterBar
                    type={type}
                    categories={categories}
                    onChangeTerm={setTerm}
                    onChangeCategory={setCategory}
                    runSearch={runSearch}
                />
            }
            <div className="template-wrap">
                <div>

                    {enableBar && !loading && hasResults &&
                        <p>{first} to {last} of {total} results.</p>
                    }
                    {enableBar && !loading && !hasResults &&
                        <p>{total} results.</p>
                    }
                    {enableBar && loading &&
                        <p>Loading</p>
                    }

                    {models && models.map((model) => {
                        const { guid } = model;
                        return (
                            <ResultItem key={guid} model={model} />
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export { LargeCalendarFilter };
